import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminChannelsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('channel');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
